import { render } from "./bulkSupplierZFQualityDataList.vue?vue&type=template&id=7d638534&scoped=true"
import script from "./bulkSupplierZFQualityDataList.vue?vue&type=script&lang=js"
export * from "./bulkSupplierZFQualityDataList.vue?vue&type=script&lang=js"

import "./bulkSupplierZFQualityDataList.vue?vue&type=style&index=0&id=7d638534&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d638534"]])

export default __exports__